import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50" }
const _hoisted_2 = { class: "tw-border-b tw-border-slate-200/70 tw-px-4 tw-pb-3 tw-pt-3" }
const _hoisted_3 = { class: "tw-flex tw-flex-nowrap tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_4 = { class: "tw-min-w-0 tw-flex-1 tw-overflow-x-auto" }
const _hoisted_5 = { class: "tw-flex tw-flex-nowrap tw-gap-2 tw-whitespace-nowrap" }
const _hoisted_6 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-600 tw-ml-2 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
}
const _hoisted_7 = { class: "tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3"
}
const _hoisted_9 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_10 = { class: "tw-flex-1 tw-min-h-0 tw-overflow-auto tw-px-4 tw-py-3" }
const _hoisted_11 = {
  key: 0,
  class: "tw-flex tw-items-center tw-justify-center tw-py-10"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-gradient-to-br tw-from-white/70 tw-via-white/50 tw-to-indigo-50/50 tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_15 = { class: "tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-2 tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-3 sm:tw-px-5" }
const _hoisted_16 = { class: "tw-min-w-0" }
const _hoisted_17 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_18 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1 tw-text-sm tw-text-slate-600" }
const _hoisted_23 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-1"
}
const _hoisted_24 = { class: "tw-font-medium tw-text-slate-800" }
const _hoisted_25 = { class: "tw-inline-flex tw-items-center tw-gap-1" }
const _hoisted_26 = { class: "tw-flex tw-flex-shrink-0 tw-items-center tw-gap-2" }
const _hoisted_27 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-slate-700"
}
const _hoisted_28 = { class: "tw-font-semibold" }
const _hoisted_29 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-amber-200/70 tw-bg-amber-50/70 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-amber-900"
}
const _hoisted_30 = { class: "tw-font-semibold" }
const _hoisted_31 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-emerald-200/70 tw-bg-emerald-50/70 tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-emerald-800"
}
const _hoisted_32 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 tw-px-4 tw-py-3 sm:tw-px-5" }
const _hoisted_33 = { class: "tw-grid tw-grid-cols-1 tw-gap-2" }
const _hoisted_34 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_35 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_36 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_37 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_38 = { class: "tw-grid tw-grid-cols-1 tw-gap-2" }
const _hoisted_39 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_40 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_43 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_44 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_47 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_48 = { class: "tw-mt-0.5 tw-text-sm tw-font-medium tw-text-slate-900" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "tw-text-slate-500"
}
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { class: "tw-p-5" }
const _hoisted_53 = { class: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-3" }
const _hoisted_54 = { class: "tw-ml-1" }
const _hoisted_55 = {
  key: 1,
  class: "tw-rounded-xl tw-border tw-border-amber-200/70 tw-bg-amber-50/70 tw-p-3 tw-text-sm tw-text-amber-900"
}
const _hoisted_56 = { class: "sm:tw-self-end sm:tw-pb-2" }
const _hoisted_57 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_58 = { class: "sm:tw-col-start-1" }
const _hoisted_59 = { class: "tw-mt-5 tw-flex tw-justify-end tw-gap-2" }
const _hoisted_60 = { class: "tw-w-full tw-text-center tw-p-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_61 = {
  key: 0,
  class: "tw-mt-2 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4 tw-text-left"
}
const _hoisted_62 = { class: "tw-mt-3" }
const _hoisted_63 = { class: "tw-mt-4 tw-flex tw-justify-center tw-gap-2" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "tw-mb-0" }
const _hoisted_68 = {
  key: 0,
  class: "tw-mt-0"
}
const _hoisted_69 = { class: "tw-mt-0 tw-mb-0" }
const _hoisted_70 = { class: "tw-mt-0" }
const _hoisted_71 = { class: "tw-mt-3 tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-center tw-gap-2" }
const _hoisted_72 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60",
  type: "button",
  title: "Drop-off cannot be edited after order is created",
  disabled: ""
}
const _hoisted_73 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60",
  title: "Add Bill of Lading to this container to add Orders",
  disabled: ""
}
const _hoisted_74 = {
  key: 1,
  class: "tw-mt-3 tw-flex tw-w-full tw-justify-center"
}
const _hoisted_75 = {
  key: 2,
  class: "tw-mt-3 tw-flex tw-w-full tw-justify-center"
}
const _hoisted_76 = { class: "tw-w-full tw-text-center tw-p-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/50 tw-p-2.5" }
const _hoisted_77 = {
  key: 0,
  class: "tw-mt-4 tw-flex tw-flex-col tw-items-center"
}
const _hoisted_78 = { class: "tw-mt-0 tw-mb-0" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-500"
}
const _hoisted_82 = {
  key: 0,
  class: "tw-mt-6 tw-border-t tw-border-slate-200/70 tw-pt-4"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-rose-200 tw-bg-rose-50/60 tw-px-4 tw-py-3 tw-text-center"
}
const _hoisted_85 = { class: "tw-text-sm tw-font-medium tw-text-rose-800" }
const _hoisted_86 = { class: "tw-flex tw-gap-2" }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = { key: 2 }
const _hoisted_89 = { key: 3 }
const _hoisted_90 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-3 sm:tw-p-4" }
const _hoisted_91 = { class: "tw-mb-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2" }
const _hoisted_92 = {
  key: 0,
  class: "tw-text-sm tw-text-rose-800"
}
const _hoisted_93 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_94 = { class: "tw-overflow-x-auto" }
const _hoisted_95 = { key: 4 }
const _hoisted_96 = { class: "tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-p-3 sm:tw-p-4" }
const _hoisted_97 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-600"
}
const _hoisted_98 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_YardStatusLabel = _resolveComponent("YardStatusLabel")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_BaseDateTimePicker = _resolveComponent("BaseDateTimePicker")!
  const _component_ContainerReturnLocationDropdown = _resolveComponent("ContainerReturnLocationDropdown")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ContainerTerminalEventsTable = _resolveComponent("ContainerTerminalEventsTable")!
  const _component_AddNotesArea = _resolveComponent("AddNotesArea")!
  const _component_ContainerReeferDetails = _resolveComponent("ContainerReeferDetails")!
  const _component_ContainerTripsTable = _resolveComponent("ContainerTripsTable")!
  const _component_VesselFinderEmbed = _resolveComponent("VesselFinderEmbed")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'details'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab('details')))
            }, " Container Details ", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'notes'
                    ? (_ctx.container?.notes?.length > 0
                      ? 'tw-border-emerald-700 tw-bg-emerald-700 tw-text-white'
                      : 'tw-border-slate-900 tw-bg-slate-900 tw-text-white')
                    : (_ctx.container?.notes?.length > 0
                      ? 'tw-border-emerald-300 tw-bg-emerald-50 tw-text-emerald-700 hover:tw-bg-emerald-100'
                      : 'tw-border-slate-200 tw-bg-gray-100 tw-text-slate-700 hover:tw-bg-slate-50')]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab('notes')))
            }, [
              _cache[32] || (_cache[32] = _createTextVNode(" Notes ", -1)),
              (_ctx.container?.notes?.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.container.notes.length), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.isReefer)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'reefer'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('reefer')))
                }, " Reefer ", 2))
              : _createCommentVNode("", true),
            (_ctx.container && _ctx.container.order)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'dispatch'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTab('dispatch')))
                }, " Dispatch ", 2))
              : _createCommentVNode("", true),
            (_ctx.enableVessel === true && _ctx.container && _ctx.container.vessel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'vessel'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTab('vessel')))
                }, " Vessel Tracking ", 2))
              : _createCommentVNode("", true),
            (_ctx.container && _ctx.container.linerContainerEvents && _ctx.container.linerContainerEvents.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  type: "button",
                  class: _normalizeClass(["tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium", _ctx.activeTab === 'shipline'
                    ? 'tw-border-transparent tw-bg-slate-900 tw-text-white'
                    : 'tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white']),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setTab('shipline')))
                }, " Shipline Events ", 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.container && !_ctx.container.billOfLading && !_ctx.editingBL)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                isDefault: true,
                class: "tw-px-2 tw-py-1 tw-text-xs",
                onClick: _ctx.addBL,
                title: "Add Bill of Lading"
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                  _createTextVNode(" Add BL ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.container && !_ctx.container.billOfLading && _ctx.editingBL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_InputField, {
              class: "tw-w-[220px]",
              id: "BL",
              modelValue: _ctx.editingBillOfLading,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingBillOfLading) = $event)),
              placeholder: "Bill of Lading"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              class: "tw-px-2 tw-py-1 tw-text-xs",
              onClick: _ctx.saveBillOfLading
            }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode("Save", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "tw-px-2 tw-py-1 tw-text-xs",
              isGray: true,
              onClick: _ctx.cancelBLAddition
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.$apollo.queries.container.loading && (!_ctx.container || _ctx.container.id !== _ctx.containerId))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              icon: "circle-notch",
              spin: "",
              class: "tw-h-8 tw-w-8 tw-text-slate-500"
            })
          ]))
        : (_ctx.container)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.activeTab === 'details')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[37] || (_cache[37] = _createElementVNode("h2", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Container details", -1)),
                            (_ctx.container.owner)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.container.owner), 1))
                              : _createCommentVNode("", true),
                            (_ctx.container.isCancelled)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-rose-50 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-rose-800 tw-ring-1 tw-ring-inset tw-ring-rose-600/20",
                                  title: _ctx.container.cancelledReason || 'Cancelled on order'
                                }, [
                                  _cache[36] || (_cache[36] = _createTextVNode(" Cancelled ", -1)),
                                  (_ctx.container.cancelledReason)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " — " + _toDisplayString(_ctx.container.cancelledReason), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_19))
                              : (_ctx.container.yardStatusDescription)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    _createVNode(_component_YardStatusLabel, {
                                      container: _ctx.container,
                                      enableStale: false
                                    }, null, 8, ["container"])
                                  ]))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            (_ctx.container.sizeType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "tw-text-slate-500" }, "Size/Type", -1)),
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.container.sizeType), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "tw-hidden sm:tw-block tw-text-slate-300" }, "|", -1)),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "tw-text-slate-500" }, "Terminal", -1)),
                              _createElementVNode("span", {
                                class: _normalizeClass(["tw-font-medium tw-text-slate-800 tw-p-1 tw-rounded-2xl", `container-terminal-${_ctx.container.terminal.toLowerCase()}`])
                              }, _toDisplayString(_ctx.container.terminal || '—'), 3)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          (_ctx.getIsEtaShownForYardStatus(_ctx.container.yardStatus))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "ETA", -1)),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.container.eta || '—'), 1)
                              ]))
                            : (_ctx.container.lfd && _ctx.container.lfd.length > 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-amber-800" }, "LFD", -1)),
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.container.lfd), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[43] || (_cache[43] = [
                                  _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide" }, "No LFD", -1)
                                ]))])),
                          _createElementVNode("div", null, [
                            _createVNode(_component_Button, {
                              onClick: _ctx.openEditContainerDetails,
                              icon: "pen-to-square"
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("dl", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _cache[44] || (_cache[44] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Vessel", -1)),
                            _createElementVNode("dd", _hoisted_35, _toDisplayString(_ctx.container.vessel ? _ctx.container.vessel.name : 'Vessel Not Available'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _cache[45] || (_cache[45] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Line", -1)),
                            _createElementVNode("dd", _hoisted_37, _toDisplayString(_ctx.container.owner || '—'), 1)
                          ])
                        ]),
                        _createElementVNode("dl", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[46] || (_cache[46] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Pick-up terminal appointment", -1)),
                            _createElementVNode("dd", _hoisted_40, [
                              (_ctx.container.terminalAppointmentDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.terminalAppointmentDate, _ctx.container.terminalAppointmentHasTime, true)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_42, "—"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _cache[47] || (_cache[47] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Delivery appointment", -1)),
                            _createElementVNode("dd", _hoisted_44, [
                              (_ctx.container.deliveryAppointmentDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.deliveryAppointmentDate, _ctx.container.deliveryAppointmentHasTime, true)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_46, "—"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _cache[48] || (_cache[48] = _createElementVNode("dt", { class: "tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Return terminal appointment", -1)),
                            _createElementVNode("dd", _hoisted_48, [
                              (_ctx.container.returnTerminalAppointmentDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.returnTerminalAppointmentDate, _ctx.container.returnTerminalAppointmentHasTime, true)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_50, "—")),
                              (_ctx.getIsReturningToDifferentLocation(_ctx.container.terminal, _ctx.container.returnLocation))
                                ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_51, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["tw-font-medium tw-text-slate-800 tw-p-1 tw-border-2 tw-rounded-2xl tw-border-dashed tw-border-red-500 tw-mx-2 tw-my-1", _ctx.getTerminalColorClassForLocation(_ctx.container.returnLocation)])
                                    }, "* " + _toDisplayString(_ctx.getLocationDisplayName(_ctx.container.returnLocation)), 3)
                                  ])), [
                                    [_directive_tippy, 'pick-up terminal and return location are DIFFERENT!']
                                  ])
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createVNode(_component_Modal, {
                          isOpen: _ctx.isEditContainerDetailsModalOpen,
                          "onUpdate:isOpen": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isEditContainerDetailsModalOpen) = $event)),
                          onClose: _ctx.closeEditContainerDetails
                        }, {
                          title: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createElementVNode("div", { class: "tw-text-base tw-font-semibold tw-tracking-tight tw-text-slate-900" }, "Edit container", -1)
                          ]))]),
                          subtitle: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                            _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "Update fields, then save.", -1)
                          ]))]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createVNode(_component_FilterableDropdown, {
                                  autofocus: "",
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.editingContainer.size,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingContainer.size) = $event)),
                                  textLabel: "Container Size",
                                  placeholder: "find & select size...",
                                  options: _ctx.containerSizes,
                                  components: { Deselect: null }
                                }, null, 8, ["modelValue", "options"]),
                                _createVNode(_component_FilterableDropdown, {
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.editingContainer.type,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingContainer.type) = $event)),
                                  textLabel: "Container Type",
                                  placeholder: "find & select type...",
                                  options: _ctx.containerTypes,
                                  label: "label",
                                  reduce: (type) => type.value,
                                  components: { Deselect: null }
                                }, null, 8, ["modelValue", "options", "reduce"]),
                                _createVNode(_component_FilterableDropdown, {
                                  class: "sm:tw-col-start-1",
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.editingContainer.vessel,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingContainer.vessel) = $event)),
                                  textLabel: "Vessel Name",
                                  placeholder: "find & select vessel...",
                                  label: "name",
                                  options: _ctx.vessels || [],
                                  reduce: (vessel) => vessel.name,
                                  "create-option": (vesselName) => ({ name: vesselName }),
                                  components: { Deselect: null }
                                }, null, 8, ["modelValue", "options", "reduce", "create-option"]),
                                (_ctx.hasBillOfLadingForEta)
                                  ? (_openBlock(), _createBlock(_component_BaseDateTimePicker, {
                                      key: 0,
                                      type: "date",
                                      textLabel: "Vessel ETA",
                                      "value-type": "format",
                                      format: "MM/DD/YYYY",
                                      "show-days-shortcuts": true,
                                      "controls-placement": "popup",
                                      modelValue: _ctx.editingContainer.eta,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingContainer.eta) = $event))
                                    }, {
                                      "label-suffix": _withCtx(() => [
                                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_54, [
                                          _createVNode(_component_font_awesome_icon, { icon: "circle-question" })
                                        ])), [
                                          [_directive_tippy, 'Expected vessel arrival. Shared for all containers on this bill of lading.']
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_55, " Add a bill of lading before setting vessel ETA. ")),
                                _createVNode(_component_BaseDateTimePicker, {
                                  type: "date",
                                  textLabel: "Last Free Day",
                                  "value-type": "format",
                                  format: "MM/DD/YYYY",
                                  "show-days-shortcuts": true,
                                  "controls-placement": "popup",
                                  modelValue: _ctx.editingContainer.lfd,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingContainer.lfd) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_FilterableDropdown, {
                                  class: "sm:tw-col-start-1",
                                  taggable: "",
                                  "push-tag": "",
                                  modelValue: _ctx.editingContainer.terminal,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingContainer.terminal) = $event)),
                                  textLabel: "Terminal",
                                  placeholder: "find & select terminal...",
                                  options: _ctx.terminals,
                                  label: "label",
                                  reduce: (type) => type.value,
                                  components: { Deselect: null }
                                }, null, 8, ["modelValue", "options", "reduce"]),
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("label", _hoisted_57, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingContainer.isReturningToAnotherLocation) = $event)),
                                      type: "checkbox",
                                      class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.editingContainer.isReturningToAnotherLocation]
                                    ]),
                                    _cache[51] || (_cache[51] = _createTextVNode(" Return to Another Location? ", -1))
                                  ])
                                ]),
                                (_ctx.editingContainer.isReturningToAnotherLocation)
                                  ? (_openBlock(), _createBlock(_component_ContainerReturnLocationDropdown, {
                                      key: 2,
                                      modelValue: _ctx.editingContainer.returnLocation,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.editingContainer.returnLocation) = $event)),
                                      textLabel: "Return Location",
                                      placeholder: "find & select customer or terminal..."
                                    }, null, 8, ["modelValue"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_58, [
                                  _createVNode(_component_BaseDateTimePicker, {
                                    "value-type": "YYYY-MM-DD HH:mm",
                                    "date-format": "MM/DD/YYYY",
                                    "date-time-format": "MM/DD/YYYY HH:mm",
                                    "allow-time-toggling": true,
                                    "show-days-shortcuts": true,
                                    "controls-placement": "popup",
                                    "minute-step": 15,
                                    textLabel: "Pick-Up Terminal Appt",
                                    "time-panel-placement": "beside-calendar",
                                    modelValue: _ctx.editingContainer.terminalAppointmentDate,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editingContainer.terminalAppointmentDate) = $event)),
                                    "has-time": _ctx.editingContainer.terminalAppointmentHasTime,
                                    "onUpdate:hasTime": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editingContainer.terminalAppointmentHasTime) = $event))
                                  }, null, 8, ["modelValue", "has-time"])
                                ]),
                                _createVNode(_component_BaseDateTimePicker, {
                                  "value-type": "YYYY-MM-DD HH:mm",
                                  "date-format": "MM/DD/YYYY",
                                  "date-time-format": "MM/DD/YYYY HH:mm",
                                  "allow-time-toggling": true,
                                  "show-days-shortcuts": true,
                                  "controls-placement": "popup",
                                  "time-panel-placement": "beside-calendar",
                                  "minute-step": 15,
                                  textLabel: _ctx.container.isExport ? 'Pick-Up Appt' : 'Delivery Appt',
                                  modelValue: _ctx.editingContainer.deliveryAppointmentDate,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editingContainer.deliveryAppointmentDate) = $event)),
                                  "has-time": _ctx.editingContainer.deliveryAppointmentHasTime,
                                  "onUpdate:hasTime": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editingContainer.deliveryAppointmentHasTime) = $event))
                                }, null, 8, ["textLabel", "modelValue", "has-time"]),
                                _createVNode(_component_BaseDateTimePicker, {
                                  "value-type": "YYYY-MM-DD HH:mm",
                                  "date-format": "MM/DD/YYYY",
                                  "date-time-format": "MM/DD/YYYY HH:mm",
                                  "allow-time-toggling": true,
                                  "show-days-shortcuts": true,
                                  "controls-placement": "popup",
                                  "time-panel-placement": "beside-calendar",
                                  "minute-step": 15,
                                  textLabel: "Return Terminal Appt",
                                  modelValue: _ctx.editingContainer.returnTerminalAppointmentDate,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editingContainer.returnTerminalAppointmentDate) = $event)),
                                  "has-time": _ctx.editingContainer.returnTerminalAppointmentHasTime,
                                  "onUpdate:hasTime": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editingContainer.returnTerminalAppointmentHasTime) = $event))
                                }, null, 8, ["modelValue", "has-time"])
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_Button, {
                                  isGreen: true,
                                  icon: "check",
                                  onClick: _ctx.saveEditContainerDetails
                                }, {
                                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                    _createTextVNode("Save", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_Button, {
                                  isRed: true,
                                  isSecondary: true,
                                  onClick: _ctx.closeEditContainerDetails
                                }, {
                                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                                    _createTextVNode("Cancel", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["isOpen", "onClose"]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[56] || (_cache[56] = _createElementVNode("h3", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Drop-off location", -1)),
                          (_ctx.isEditingCustomer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "Select a customer for the drop-off.", -1)),
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_FilterableDropdown, {
                                    modelValue: _ctx.customerQuery,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.customerQuery) = $event)),
                                    onSearchChange: _ctx.onReceivingCustomerSearch,
                                    id: "Customer",
                                    options: _ctx.receivingCustomers || [],
                                    placeholder: "Enter Drop-Off Name",
                                    class: "tw-w-full",
                                    customLabel: 
                              (x) => (x.displayName ? x.displayName : x.name)
                            
                                  }, null, 8, ["modelValue", "onSearchChange", "options", "customLabel"])
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("button", {
                                    class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-white",
                                    type: "button",
                                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.cancelCustomerEdit && _ctx.cancelCustomerEdit(...args)))
                                  }, " Cancel "),
                                  _createElementVNode("button", {
                                    class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60",
                                    type: "button",
                                    onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.updateCustomer && _ctx.updateCustomer(...args))),
                                    disabled: !_ctx.customerQuery
                                  }, " Save Drop-Off ", 8, _hoisted_64)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                (_ctx.container.customer)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.container.customer.name), 1),
                                      (_ctx.container.customer.deliveryAddress)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                            _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.container.customer.deliveryAddress.streetAddress), 1),
                                            _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.addressLine3(_ctx.container.customer.deliveryAddress)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("div", null, [
                                          (_ctx.canAddDropOff)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800",
                                                type: "button",
                                                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.startCustomerEdit && _ctx.startCustomerEdit(...args)))
                                              }, " Edit Drop-Off "))
                                            : (_openBlock(), _createElementBlock("button", _hoisted_72, " Edit Drop-Off "))
                                        ]),
                                        _createElementVNode("div", null, [
                                          (_ctx.container.billOfLading && !_ctx.container.order)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800",
                                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showNewOrder(_ctx.container)))
                                              }, " Add Order "))
                                            : (!_ctx.container.billOfLading)
                                              ? (_openBlock(), _createElementBlock("button", _hoisted_73, " Add Order "))
                                              : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : (_ctx.canAddDropOff)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        _createElementVNode("button", {
                                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800",
                                          type: "button",
                                          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.startCustomerEdit && _ctx.startCustomerEdit(...args)))
                                        }, " Add Drop-Off ")
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_75, [...(_cache[55] || (_cache[55] = [
                                        _createElementVNode("button", {
                                          class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-opacity-60",
                                          type: "button",
                                          title: "Drop-off cannot be added after order is created",
                                          disabled: ""
                                        }, " Add Drop-Off ", -1)
                                      ]))]))
                              ]))
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          (_ctx.container.order)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _cache[59] || (_cache[59] = _createElementVNode("h3", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Order Details", -1)),
                                _createElementVNode("p", _hoisted_78, " Order # " + _toDisplayString(_ctx.container.order.id), 1),
                                (_ctx.container.order.status == 'In Progress')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_79, [...(_cache[57] || (_cache[57] = [
                                      _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-emerald-800" }, "In Progress", -1)
                                    ]))]))
                                  : (_ctx.container.order.status == 'Complete')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_80, [...(_cache[58] || (_cache[58] = [
                                        _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-amber-100 tw-px-2 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-amber-800" }, "Completed", -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                (_ctx.container.order)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white hover:tw-bg-slate-800",
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showOrder(_ctx.container.order)))
                                    }, " Order Details "))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[60] || (_cache[60] = _createElementVNode("h2", { class: "tw-mt-6 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900" }, "Container Events at Terminal", -1)),
                      (_ctx.container.containerEvents.length > 0)
                        ? (_openBlock(), _createBlock(_component_ContainerTerminalEventsTable, {
                            key: 0,
                            containerEvents: _ctx.container.containerEvents,
                            terminal: _ctx.container.dischargeTerminal
                          }, null, 8, ["containerEvents", "terminal"]))
                        : _createCommentVNode("", true),
                      (!_ctx.container.containerEvents || _ctx.container.containerEvents.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_81, "No terminal events recorded yet."))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.container && (_ctx.showArchiveButton || _ctx.showUnarchiveButton))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                          (!_ctx.isArchiveConfirmOpen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                (_ctx.showArchiveButton)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      isRed: true,
                                      isSecondary: true,
                                      class: "tw-px-3 tw-py-1.5 tw-text-xs",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.isArchiveConfirmOpen = true))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "box-archive",
                                          class: "tw-mr-1.5"
                                        }),
                                        _cache[61] || (_cache[61] = _createTextVNode(" Archive Container ", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.showUnarchiveButton)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      isRed: true,
                                      isSecondary: true,
                                      class: "tw-px-3 tw-py-1.5 tw-text-xs",
                                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isArchiveConfirmOpen = true))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "box-open",
                                          class: "tw-mr-1.5"
                                        }),
                                        _cache[62] || (_cache[62] = _createTextVNode(" Unarchive Container ", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                _createElementVNode("span", _hoisted_85, " Are you sure you want to " + _toDisplayString(_ctx.showArchiveButton ? 'archive' : 'unarchive') + " this container? ", 1),
                                _createElementVNode("div", _hoisted_86, [
                                  _createVNode(_component_Button, {
                                    isRed: true,
                                    class: "tw-px-3 tw-py-1.5 tw-text-xs",
                                    onClick: _ctx.confirmArchiveAction
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Yes, " + _toDisplayString(_ctx.showArchiveButton ? 'Archive' : 'Unarchive'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_Button, {
                                    isGray: true,
                                    class: "tw-px-3 tw-py-1.5 tw-text-xs",
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isArchiveConfirmOpen = false))
                                  }, {
                                    default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                                      _createTextVNode(" Cancel ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.activeTab === 'notes')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createVNode(_component_AddNotesArea, {
                        onAddedNote: _ctx.onAddedNote,
                        notes: _ctx.container.notes,
                        archivedNotes: _ctx.container.archivedNotes,
                        container: _ctx.container
                      }, null, 8, ["onAddedNote", "notes", "archivedNotes", "container"])
                    ]))
                  : (_ctx.activeTab === 'reefer' && _ctx.isReefer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createVNode(_component_ContainerReeferDetails, { container: _ctx.container }, null, 8, ["container"])
                      ]))
                    : (_ctx.activeTab === 'dispatch')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _cache[64] || (_cache[64] = _createElementVNode("h2", { class: "tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900" }, "Dispatch", -1)),
                              (_ctx.container.isCancelled)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_92, " Trips cannot be edited - container is cancelled on its order. "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_93, "Trips"))
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              (_ctx.container && _ctx.container.order)
                                ? (_openBlock(), _createBlock(_component_ContainerTripsTable, {
                                    key: 0,
                                    caller: "dispatch",
                                    editable: !_ctx.container.isCancelled,
                                    order: _ctx.container.order,
                                    container: _ctx.container,
                                    trips: _ctx.container.trips,
                                    drivers: _ctx.drivers,
                                    onRefreshOrders: _ctx.refreshTrips,
                                    onRefreshorders: _ctx.refreshTrips
                                  }, null, 8, ["editable", "order", "container", "trips", "drivers", "onRefreshOrders", "onRefreshorders"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_ctx.activeTab === 'vessel')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              (_ctx.container && _ctx.container.vessel && _ctx.container.vessel.mssi)
                                ? (_openBlock(), _createBlock(_component_VesselFinderEmbed, {
                                    key: 0,
                                    mssi: _ctx.container.vessel.mssi,
                                    height: 560
                                  }, null, 8, ["mssi"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_97, "No vessel tracking available for this container."))
                            ])
                          ]))
                        : (_ctx.activeTab === 'shipline')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [...(_cache[65] || (_cache[65] = [
                              _createElementVNode("div", { class: "tw-text-sm tw-text-slate-600" }, "No shipline events view configured.", -1)
                            ]))]))
                          : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}